<template>
  <NuxtLayout>
    <div class="offerDetail">
      <HeroHeader class="offersHeader heroHeader__StackedElements" :title-visible="false">
        <div class="heroHeader__StackedElementsContent container">
          <div class="offersHeader__Texts">
            <h1 v-text="page.title" />
    
            <div class="offersHeader__Accommodation">
              <template v-if="accommodation">
                <h2 v-text="accommodation.name" />
                <div class="offerDetail__StarsWrapper">
                  <Icon name="star" v-for="i in accommodation.category_rating" :key="i" />
                </div>
              </template>
              <template v-else>
                <h2 v-text="$t('offerDetail.moreAccommodations')" />
              </template>
            </div>
          </div>
  
          <div v-if="page.image_discount" class="offersHeader__DiscountWrapper">
            <Flare :srcset="page.image_discount" width="300" :alt="page.image_discount" />
          </div>
        </div>
      </HeroHeader>
      
      <div class="offerDetail__Content">
        <aside v-if="accommodation" class="offerDetail__Aside">
          <h3 v-text="accommodation.name" />

          <Button v-if="accommodationsDates" @click="getUnitListingLink" class="button--Primary">{{ $t('bookNow') }}</Button>
        </aside>
  
        <CMSField v-if="page?.content" :data="page.content" />
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
  import { isEqual, isAfter, isBefore, startOfDay, endOfDay } from 'date-fns';
  const props = defineProps({
    page: {
      type: Object
    }
  });

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  });

  const { lang } = useLanguage();
  const { accommodationsData, link } = useSetup();
  const { getAvailabilityDates, updateSearchDates } = useAvailabilityDates();
  const accommodationsDates = ref(null);

  const accommodation = computed(() => {
    if (props.page.accommodations?.length === 1) {
      let result = accommodationsData.value[props.page.accommodations[0]];
      const brandClass = useCamelCase(result.brand.theme_class);
      if (brandClass && document) {
        document.documentElement.style.setProperty('--themeColor', `var(--${brandClass})`);
        document.documentElement.style.setProperty('--themeColorDarken', `var(--${brandClass}Darken)`);
      }
      return result;
    }
    return '';
  });

  function getUnitListingLink() {
    updateSearchDates(accommodation.value.availability_calendar);
    let fullLink = { path: link('AccommodationUnitList'), query: { accommodation_id: accommodation.value.id } }
    if (props.page.package_external_id) fullLink.query.package_external_id = props.page.package_external_id;
    return navigateTo(fullLink);
  }

  onMounted(async () => {
    let { book_date_from: dateFrom, book_date_to: dateTo } = props.page;

    if (accommodation.value?.availability_calendar?.length) {
      accommodationsDates.value = getAvailabilityDates(accommodation.value.availability_calendar);
    }
    
    try {
      const today = new Date();
      dateFrom = startOfDay(dateFrom);
      dateTo = endOfDay(dateTo);
      if (dateFrom && dateTo) {
        if (!((isAfter(today, dateFrom) || isEqual(dateFrom, today)) && (isBefore(today, dateTo) || isEqual(today, dateTo)))) {
          const redirectPath = `/${ props.page.sef.split('/').filter(i => i).slice(0, -1).join('/') }/` || link('OfferList');
          if (import.meta.client) sessionStorage.setItem('offerExpired', true);
          await navigateTo(redirectPath);
        }
      }
    } catch(error) {
      console.log(error)
    }
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_offers.scss');
  @import url('@/assets/styles/pages/_offerDetail.scss');
</style>